import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import NavLink from "react-bootstrap/NavLink"
import DateRange from "@material-ui/icons/DateRange";
import FileCopy from '@material-ui/icons/FileCopy'
import Update from "@material-ui/icons/Update";
import Person from "@material-ui/icons/Person";
import Timeline from "@material-ui/icons/Timeline";
import BarChart from "@material-ui/icons/BarChart";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import Table from "components/Table/Table.js";
import Star from '@material-ui/icons/Star';
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import moment from 'moment';
import Button from 'components/CustomButtons/Button'
import analytics from "util/analytics";
import Image from 'react-bootstrap/Image';
import CardAvatar from 'components/Card/CardAvatar';
import { Link } from "util/router.js";
import ClassDashboard from 'components/ClassDashboard'
import * as rp from 'request-promise';
import STRIPE_IMAGE from "assets/img/connect_stripe.png"
import { Helmet } from 'react-helmet'
import LinkCopierCard from "components/LinkCopierCard";

const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;

const useStyles = makeStyles(styles);


function SharePage(props) {

    const classes = useStyles();

    const { history, match, children } = props;
    console.log("Match: " + match)

    moment.locale('en', {
        calendar: {
            lastDay: '[Yesterday]',
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            lastWeek: '[last] dddd [at] LT',
            nextWeek: 'dddd [at] LT',
            sameElse: 'dddd MMM Do'
        }
    });

    const instructor = useSelector(state => state.user.userData)

    const [showCopyLink, setCopyLink] = useState(false);
    function handleWidgetLinkClick(e) {
        e.preventDefault()
        var input = document.createElement('input');
        input.setAttribute('value', "sutrapro.com/" + instructor.widgetName);
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        setCopyLink(true);

        setTimeout(function () {
            setCopyLink(false);
        }, 2000);
    }

    return (
        <div className="container">
            <Helmet>
                <title>Share Public Page</title>
            </Helmet>
            {/* <h2 className="font-weight-bold">Share Public Page</h2> */}

            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={4}>
                    <LinkCopierCard
                        title="Profile Widget"
                        subtitle="Great for Instagram link-in-bio! Share your schedule and pricing options."
                        link={instructor?.widgetName ? `sutrapro.com/${instructor.widgetName}` : ""}
                    />

                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={4}>
                    <LinkCopierCard
                        title="Schedule Widget"
                        subtitle="Great for Instagram link-in-bio! Only share your upcoming schedule"
                        link={instructor?.widgetName ? `sutrapro.com/${instructor.widgetName}/schedule` : ""}
                    />
                </GridItem>
            </GridContainer>

            {children}

            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>

                    <Card>
                        <CardHeader color="primary" icon>
                            <div className="d-flex d-row align-items-center">
                                <h3 className={classes.cardTitle}>
                                    <small>Embed your schedule</small>
                                </h3>
                                <a className="ml-2" target="_blank" href={`https://sutrapro.com/iframe/${instructor.widgetName}/schedule`}>Preview</a>
                            </div>
                            <p className={classes.cardCategory}>Copy and paste to embed your schedule in your own website!</p>
                            {/* <p className={classes.cardCategory}>Click to copy your link</p> */}
                        </CardHeader>
                        <CardBody>
                            <pre>
                                <code>
                                    {/* &lt;p&gt;Sample text here...&lt;/p&gt;&lt;p&gt;And another line of sample text here...&lt;/p&gt; */}
                                    {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/schedule"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                                </code>
                            </pre>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>

                    <Card>
                        <CardHeader color="primary" icon>
                            <div className="d-flex d-row align-items-center">
                                <h3 className={classes.cardTitle}>
                                    <small>Embed your on demand library</small>
                                </h3>
                                <a className="ml-2" target="_blank" href={`https://sutrapro.com/iframe/${instructor.widgetName}/videos`}>Preview</a>
                            </div>
                            <p className={classes.cardCategory}>Copy and paste to embed your on-demand library into your own website!</p>
                        </CardHeader>
                        <CardBody>
                            <pre>
                                <code>
                                    {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/videos"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                                </code>
                            </pre>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>

                    <Card>
                        <CardHeader color="primary" icon>
                            <div className="d-flex d-row align-items-center">
                                <h3 className={classes.cardTitle}>
                                    <small>Embed your pricing options</small>
                                </h3>
                                <a className="ml-2" target="_blank" href={`https://sutrapro.com/iframe/${instructor.widgetName}/pricing/cards`}>Preview</a>
                            </div>
                            <p className={classes.cardCategory}>Copy and paste to embed your pricing options into your own website!</p>
                        </CardHeader>
                        <CardBody>
                            <pre>
                                <code>
                                    {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/pricing/cards"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                                </code>
                            </pre>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>

                    <Card>
                        <CardHeader color="primary" icon>
                            <div className="d-flex d-row align-items-center">
                                <h3 className={classes.cardTitle}>
                                    <small>Embed your Gift Card page</small>
                                </h3>
                                <a className="ml-2" target="_blank" href={`https://sutrapro.com/iframe/${instructor.widgetName}/gifting`}>Preview</a>
                            </div>
                            <p className={classes.cardCategory}>Copy and paste to embed your gift card page into your own website!</p>
                        </CardHeader>
                        <CardBody>
                            <pre>
                                <code>
                                    {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/gifting"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                                </code>
                            </pre>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>

                    <Card>
                        <CardHeader color="primary" icon>
                            <div className="d-flex d-row align-items-center">
                                <h3 className={classes.cardTitle}>
                                    <small>Embed a list of all your communities</small>
                                </h3>
                                <a className="ml-2" target="_blank" href={`https://sutrapro.com/iframe/${instructor.widgetName}/series`}>Preview</a>
                            </div>
                            <p className={classes.cardCategory}>Copy and paste to embed your communities page into your own website!</p>
                        </CardHeader>
                        <CardBody>
                            <pre>
                                <code>
                                    {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/series"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                                </code>
                            </pre>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={6}>

                    <Card>
                        <CardHeader color="primary" icon>
                            <div className="d-flex d-row align-items-center">
                                <h3 className={classes.cardTitle}>
                                    <small>Embed your Events Page</small>
                                </h3>
                                <a className="ml-2" target="_blank" href={`https://sutrapro.com/iframe/${instructor.widgetName}/schedule?type=event`}>Preview</a>
                            </div>
                            <p className={classes.cardCategory}>Copy and paste to embed only your upcoming events</p>
                        </CardHeader>
                        <CardBody>
                            <pre>
                                <code>
                                    {(`<iframe
id="sutraWidgetIframe"
src="https://sutrapro.com/iframe/${instructor.widgetName}/schedule?type=event"
width="100%"
frameBorder="0"
allowfullscreen></iframe>
<script src="https://sutrapro.com/scripts/embed.js"></script>`)}
                                </code>
                            </pre>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>

        </div>
    );
}

export default SharePage;
